import { makeActions } from 'redux/crudCreator/actions';

export const MODEL_NAME = 'centreServices';
export const centreServicesActions = makeActions(MODEL_NAME);

export const getAllCentreServices = centreServicesActions.getAll;
export const editCentreServices = centreServicesActions.edit;
export const createCentreServices = centreServicesActions.create;
export const getByIdCentreServices = centreServicesActions.getDataById;
